import React from 'react'
import { Link } from "react-router-dom";
import local from "../../../localization/strings";

const SearchResultUser = ({item, close}) => {
    return (
		<div className="p-2">
			<Link to="/site_settings/site_management" className="text-nowrap" onClick={close}>
				<b>{local.TF_Search_User}:</b> {item.entityName}
			</Link>
		</div>
	);
}

export default SearchResultUser;